import React from 'react';
import {useLocation} from 'react-router-dom';
import LoginComponent from '../../components/authentication/LoginComponent';

// Only allow same-origin relative paths (block //evil.com, https://..., /admin loops)
const sanitizeRedirectPath = (path) => {
    if (!path || typeof path !== 'string') return '/dashboard';
    if (!path.startsWith('/')) return '/dashboard';
    if (path.startsWith('//')) return '/dashboard';
    if (path === '/admin' || path.startsWith('/admin/')) return '/dashboard';
    if (path === '/login' || path.startsWith('/login/')) return '/dashboard';
    if (path === '/logout' || path === '/register') return '/dashboard';
    return path;
};

const Login = () => {
    const location = useLocation();
    let redirect_url = '/dashboard';
    
    const urlParams = new URLSearchParams(location.search);
    const redirectParam = urlParams.get('redirect');
    
    if (redirectParam) {
        redirect_url = sanitizeRedirectPath(redirectParam);
    } else if (location.state?.from?.pathname) {
        redirect_url = sanitizeRedirectPath(location.state.from.pathname);
    }

    return (
        <div className="  ">
            <LoginComponent redirect={redirect_url} />
        </div>   
    )
}

export default Login;
